import { useInfiniteQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetLoanSecurityByFundraisingId = id => {
  return useInfiniteQuery({
    queryKey: [QUERY_KEYS.loan.loan_security_by_fundraising_id, id],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await loanService.loanSecurityByFundraisingId(id, {
        page: pageParam,
        limit: 10,
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      }
      throw new Error('Fetch failed');
    },
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage) return;
      const currentPage = allPages.length;
      const hasNextPage = currentPage < lastPage.total_pages;
      return hasNextPage ? currentPage + 1 : undefined;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
